export default __webpack_public_path__ + "static/media/winter-landscape.b528bc7c.jpg";